import { MouseEvent, ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListOl, faListUl } from '@fortawesome/free-solid-svg-icons';
import { Box, Grid, Theme } from '@mui/material';
import { IconButton } from '@components/iconButton';
import { LinkMedium } from '@assets/svgs';
import { INLINE_STYLES, iconStyle } from './RichTextEditor.styles';

interface IRichTextControls {
  updateStyle: (style: string) => void;
  updateLink: (e: MouseEvent<HTMLElement>) => void;
  isDisabled?: boolean;
  /** Defaults to bold, italic and underline. */
  inlineStyles?: readonly { icon: ReactElement; style: string }[];
  /** When set, shows bulleted / numbered list buttons. */
  toggleBlockType?: (blockType: string) => void;
}

const LIST_BLOCK_TYPES = [
  { blockType: 'unordered-list-item', label: 'Bulleted list', icon: faListUl },
  { blockType: 'ordered-list-item', label: 'Numbered list', icon: faListOl },
] as const;

export const RichTextControls = ({
  updateStyle,
  updateLink,
  isDisabled = false,
  inlineStyles = INLINE_STYLES,
  toggleBlockType,
}: IRichTextControls) => {
  const onClickButton = (e: MouseEvent<HTMLElement>, style: string) => {
    e.preventDefault();
    updateStyle(style);
  };
  return (
    <Grid
      container
      direction='row'
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {inlineStyles.map((type) => (
        <IconButton
          onMouseDown={(e) => onClickButton(e, type.style)}
          key={type.style}
          disabled={isDisabled}
          sx={iconStyle}
        >
          {type.icon}
        </IconButton>
      ))}
      <Box
        sx={(theme: Theme) => ({
          display: 'inline',
          borderLeft: theme.borders.main,
          height: '24px',
        })}
      />
      <IconButton onMouseDown={updateLink} disabled={isDisabled} sx={iconStyle}>
        <LinkMedium />
      </IconButton>
      {toggleBlockType
        ? LIST_BLOCK_TYPES.map(({ blockType, label, icon }) => (
            <IconButton
              key={blockType}
              aria-label={label}
              // mousedown keeps the editor's selection; the toggle runs on click so Enter/Space work too.
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => toggleBlockType(blockType)}
              disabled={isDisabled}
              sx={iconStyle}
            >
              <FontAwesomeIcon icon={icon} />
            </IconButton>
          ))
        : null}
    </Grid>
  );
};
